import fetch from '@/utils/fetch';
import { message } from 'antd';
import moment from 'moment';
import filterNull from '@/utils/filterNull';
import { defaultFilterState } from './config';

const model = {
  state: {
    gatherOrderList: [],
    logisticsDetailsList: [],
    listLoading: false,
    total: 0,
    loading: false,
    visibleOrder: false,
    filterState: {
      page: 1,
      pageSize: 10,
      deliveryTime: [moment().subtract(6, 'days'), moment()],
      groupOrderId: '',
      shopId: '',
      shopName: '',
      sendEmployeeName: '',
      acceptEmployeeName: '',
      status: -1,
      unnormalStatus: -1,
      cityName: '',
      cbdId: '',
      deliveryMethod: 0,
      transferStationEmployeeName: '',
      taskType: 0,
      isAllocate: null,
      isPeopleIntervene: null,
      showTest: 0,
    },
    filterBussinessState: {
      page: 1,
      pageSize: 10,
      deliveryEndTime: moment().endOf('days').valueOf(),
      deliveryBeginTime: moment().subtract(6, 'days').startOf('days').valueOf(),
      deliveryTime: [moment().subtract(6, 'days').startOf('days'), moment().endOf('days')],
      groupOrderId: '',
      orderId: '',
      shopId: '',
      shopName: '',
      sendEmployeeName: '',
      acceptEmployeeName: '',
      status: -1,
      unnormalStatus: -1,
      afterSaleUnnormalStatus: -1,
      orderType: -1,
      cityName: '',
      cbdId: '',
      deliveryMethod: 0,
      isAllocate: null,
      isPeopleIntervene: null,
      showTest: 0,
    },
    bdList: [], // 商圈列表
    isFsOrder: true,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { gatherOrder, basic }, getState }) => ({
    // 查看物流详情
    viewLogisticsDetails(record) {
      gatherOrder.getLogisticsDetails(record);
      // gatherOrder.toggleModal(true);
    },
    viewLogisticsDetailsOrder(record) {
      gatherOrder.getLogisticsDetails(record);
      gatherOrder.toggleModal(true);
    },
    toggleModal(visibleOrder) {
      gatherOrder.setState({ visibleOrder });
    },
    clearFilter() {
      gatherOrder.setState({
        filterState: {
          ...defaultFilterState,
        },
      });
    },
    changeIsFsOrder(flag) {
      gatherOrder.setState({
        isFsOrder: flag,
      });
    },
    // 获取丰食配物流详情
    async getLogisticsDetails(raw) {
      const { isFsOrder } = getState().gatherOrder;
      let data;
      if (isFsOrder) {
        data = await fetch('/saasmerchant/fsarea/logistics/operation/list', {
          type: 'POST',
          params: {
            groupOrderId: raw.groupOrderId,
            orderId: raw.orderId,
          },
          useJson: true,
        });
      } else {
        data = await fetch('/saasmerchant/fsarea/logistics/three-way/order/deliveryinfo', {
          type: 'GET',
          params: {
            orderId: raw.orderId,
          },
        });
      }
      gatherOrder.setState({
        listLoading: false,
      });
      if (data) {
        if (isFsOrder) {
          gatherOrder.setState({
            logisticsDetailsList: data,
          });
        } else {
          gatherOrder.setState({
            logisticsDetailsList: data.length && data[0].traces,
          });
        }
      }
    },
    // 获取属性列表
    async getGatherOrderList() {
      const { isFsOrder } = getState().gatherOrder;
      gatherOrder.setState({ listLoading: true });
      const params = { ...getState().gatherOrder.filterState };
      const deliveryBeginTime =
        params.deliveryTime && params.deliveryTime[0]
          ? moment(params.deliveryTime[0]).startOf('days').valueOf()
          : '';
      const deliveryEndTime =
        params.deliveryTime && params.deliveryTime[1]
          ? moment(params.deliveryTime[1]).endOf('days').valueOf()
          : '';
      delete params.deliveryTime;
      const newParam = filterNull({ ...params });
      let data;
      if (isFsOrder) {
        newParam.logisticsId && delete newParam.logisticsId;
        data = await fetch('/saasmerchant/fsarea/logistics/orderlist', {
          type: 'POST',
          params: {
            page: 1,
            deliveryBeginTime,
            deliveryEndTime,
            ...newParam,
          },
          useJson: true,
        });
      } else {
        newParam.groupOrderId && delete newParam.groupOrderId;
        data = await fetch('/saasmerchant/fsarea/logistics/three-way/orderlist', {
          type: 'POST',
          params: {
            page: 1,
            deliveryBeginTime,
            deliveryEndTime,
            ...newParam,
          },
          useJson: true,
        });
      }
      gatherOrder.setState({
        listLoading: false,
      });
      if (data && data.list) {
        gatherOrder.setState({
          gatherOrderList: data.list,
          total: data.total,
          listLoading: false,
        });
      }
    },
    clearOrderList() {
      gatherOrder.setState({
        gatherOrderList: [],
        total: 0,
        listLoading: false,
      });
    },
    // 导出物流订单报表
    async exportOtherOrderList() {
      const params = { ...getState().gatherOrder.filterState };
      const { isFsOrder } = getState().gatherOrder;
      const deliveryBeginTime =
        params.deliveryTime && params.deliveryTime[0]
          ? new Date(params.deliveryTime[0]).getTime()
          : '';
      const deliveryEndTime =
        params.deliveryTime && params.deliveryTime[1]
          ? new Date(params.deliveryTime[1]).getTime()
          : '';
      delete params.deliveryTime;
      const newParams = filterNull({ ...params });
      !isFsOrder
        ? newParams.groupOrderId && delete newParams.groupOrderId
        : newParams.logisticsId && delete newParams.logisticsId;
      const data = await fetch(
        !isFsOrder
          ? '/saasmerchant/fsarea/logistics/three-way/orderlist/export'
          : '/saasmerchant/fsarea/logistics/orderlist/export',
        {
          type: 'POST',
          params: {
            page: 1,
            deliveryBeginTime,
            deliveryEndTime,
            ...newParams,
          },
          useJson: true,
        },
      );
      if (data) {
        message.success('成功添加导出任务');
        basic.setLogListDot(true);
      }
    },
    // 获取商家订单管理列表
    async getBusinessOrderList() {
      gatherOrder.setState({ listLoading: true });
      const params = { ...getState().gatherOrder.filterBussinessState };
      const newParams = { ...params };
      const logisticsId = params.groupOrderId;
      delete newParams.groupOrderId;
      delete newParams.deliveryTime;
      const data = await fetch('/saasmerchant/fsarea/logistics/shop/orderlist', {
        type: 'POST',
        params: {
          ...newParams,
          logisticsId,
        },
        useJson: true,
      });
      gatherOrder.setState({
        listLoading: false,
      });
      if (data && data.list) {
        gatherOrder.setState({
          businessOrderManagerList: data.list,
          total: data.total,
        });
      }
    },
    changePage(params) {
      const { page, pageSize } = params;
      gatherOrder.setState({ page, pageSize });
    },
    setFilter(params) {
      gatherOrder.setState({
        filterState: { ...getState().gatherOrder.filterState, ...params },
      });
    },
    setBussinessFilter(params) {
      gatherOrder.setState({
        filterBussinessState: {
          ...getState().gatherOrder.filterBussinessState,
          ...params,
        },
      });
    },
    resetfilterState() {
      const filterState = {
        page: 1,
        pageSize: 10,
        deliveryTime: [moment().subtract(6, 'days'), moment()],
        groupOrderId: '',
        shopId: '',
        shopName: '',
        sendEmployeeName: '',
        acceptEmployeeName: '',
        status: -1,
        unnormalStatus: -1,
        showTest: 0,
      };
      gatherOrder.setState({
        filterState,
      });
    },
    resetBussinessFilter() {
      const filterBussinessState = {
        page: 1,
        pageSize: 10,
        deliveryEndTime: moment().endOf('days').valueOf(),
        deliveryBeginTime: moment().subtract(6, 'days').startOf('days').valueOf(),
        deliveryTime: [moment().subtract(6, 'days').startOf('days'), moment().endOf('days')],
        groupOrderId: '',
        orderId: '',
        shopId: '',
        shopName: '',
        sendEmployeeName: '',
        acceptEmployeeName: '',
        status: -1,
        unnormalStatus: -1,
        afterSaleUnnormalStatus: -1,
        orderType: -1,
        cityName: '',
        cbdId: '',
        deliveryMethod: 0,
        showTest: 0,
      };
      gatherOrder.setState({
        filterBussinessState,
      });
    },
    // 获取商圈列表
    async getBDList(params) {
      const bdList = await fetch('/saasmerchant/fsarea/businessDistrict/authority/queryCbdList', {
        params: {
          ...params,
          cbdStatus: 1,
        },
      });
      gatherOrder.setState({ bdList: bdList || [] });
      return bdList;
    },

    clearBDList() {
      gatherOrder.setState({ bdList: [] });
    },
    // 商家订单导出
    async exporShopList() {
      const params = { ...getState().gatherOrder.filterBussinessState };
      const newParams = { ...params };
      const logisticsId = params.groupOrderId;
      delete newParams.groupOrderId;
      delete newParams.deliveryTime;
      const data = await fetch('/saasmerchant/fsarea/logistics/shop/orderlist/export', {
        type: 'POST',
        params: {
          ...newParams,
          logisticsId,
        },
        useJson: true,
      });
      if (data) {
        message.success('成功添加导出任务');
      }
    },
    // 商家订单丰食配导出
    async orderlistExport(params) {
      const data = await fetch('/saasmerchant/fsarea/logistics/shop/cls/orderlist/export', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('成功添加导出任务');
        basic.setLogListDot(true);
      }
      return data;
    },
  }),
};

export default model;
